export default __webpack_public_path__ + "static/media/weight-lifter-wreath.05c83a37.svg";